module.exports = __webpack_public_path__ + "img/market_place_items.24710488.png";